import { VITE_CASE_HISTORY_API } from 'Constants/appEnvConstants'

export default function getCaseHistoryBaseUrl() {
  // eslint-disable-next-line no-undef
  return VITE_CASE_HISTORY_API;
}
